export default {
    key: 'medical-services',
    label: 'Medical services',
    component: {
        name: 'MedicalServicesTemplate',
        loader: () => import('./MedicalServicesTemplate')
    },
    modules: {
        locations: [
            {
                label: 'Modules',
                name: 'default'
            },
        ]
    }
};
